import { render, staticRenderFns } from "./pmsComponent.vue?vue&type=template&id=037ad66e&"
import script from "./pmsComponent.vue?vue&type=script&lang=js&"
export * from "./pmsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports